// components/advertiser-wallet/constants.ts
import { RewardStatusFilter, RewardSpendSortBy, RewardSpendSortOrder } from "./types";

export const PERIOD_DAYS_OPTIONS = [
  { value: 7, label: "Weekly" },
  { value: 30, label: "Monthly" },
  { value: 90, label: "Quarterly" },
];

export const REWARD_STATUS_OPTIONS: { value: RewardStatusFilter; label: string }[] = [
  { value: "active", label: "Active" },
  { value: "inactive", label: "Inactive" },
  { value: "all", label: "All Statuses" },
];

export interface RewardSortOption {
  value: string;
  label: string;
  sortBy: RewardSpendSortBy;
  sortOrder: RewardSpendSortOrder;
}

export const REWARD_SORT_OPTIONS: RewardSortOption[] = [
  { value: "spend_desc", label: "Spend High-Low", sortBy: "spend", sortOrder: "desc" },
  { value: "spend_asc", label: "Spend Low-High", sortBy: "spend", sortOrder: "asc" },
  { value: "clicks_desc", label: "Most Clicks", sortBy: "clicks", sortOrder: "desc" },
  { value: "purchases_desc", label: "Most Purchases", sortBy: "purchases", sortOrder: "desc" },
  { value: "revenue_desc", label: "Highest Revenue", sortBy: "revenue", sortOrder: "desc" },
  { value: "created_at_desc", label: "Newest", sortBy: "created_at", sortOrder: "desc" },
  { value: "created_at_asc", label: "Oldest", sortBy: "created_at", sortOrder: "asc" },
];
